"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isWebAppEnabled = exports.isRippleBlocked = exports.ServiceLevel = exports.config = void 0;
var c = require("./config");
exports.config = c;
var ServiceLevel;
(function (ServiceLevel) {
    ServiceLevel[ServiceLevel["SERVICE_LEVEL_FREE"] = exports.config.SERVICE_LEVEL_FREE] = "SERVICE_LEVEL_FREE";
    ServiceLevel[ServiceLevel["SERVICE_LEVEL_BASIC"] = exports.config.SERVICE_LEVEL_BASIC] = "SERVICE_LEVEL_BASIC";
    ServiceLevel[ServiceLevel["SERVICE_LEVEL_ENHANCED"] = exports.config.SERVICE_LEVEL_ENHANCED] = "SERVICE_LEVEL_ENHANCED";
    ServiceLevel[ServiceLevel["SERVICE_LEVEL_ENTERPRISE"] = exports.config.SERVICE_LEVEL_ENTERPRISE] = "SERVICE_LEVEL_ENTERPRISE";
})(ServiceLevel = exports.ServiceLevel || (exports.ServiceLevel = {}));
var isRippleBlocked = function (params) {
    var rippleBlocked = false;
    if (
    // block premium ripples for free customers
    (params.appServiceLevel === exports.config.SERVICE_LEVEL_FREE &&
        params.isPremium) ||
        // block self frames for free & basic
        (params.appServiceLevel <= exports.config.SERVICE_LEVEL_BASIC &&
            params.isFrame &&
            params.appOrgId === params.rippleOrgId) ||
        // block premium ripples in self channels for basic
        (params.appServiceLevel === exports.config.SERVICE_LEVEL_BASIC &&
            params.isPremium &&
            params.appOrgId === params.channelOrgId))
        rippleBlocked = true;
    return rippleBlocked;
};
exports.isRippleBlocked = isRippleBlocked;
var isWebAppEnabled = function (serviceLevel) {
    if (serviceLevel === null)
        return true;
    if (serviceLevel <= 1)
        return false;
    return true;
};
exports.isWebAppEnabled = isWebAppEnabled;
//# sourceMappingURL=index.js.map